import { z } from "zod";
import { type FunctionObjectReturn } from "../utils";

export const ValidatePromotionCodeSchema = z.object({
  code: z.string().min(1),
});

export type ValidatePromotionCodePostBody = z.infer<typeof ValidatePromotionCodeSchema>;

export interface ValidatePromotionCode {
  valid: boolean;
  code?: {
    percent_off: number | null;
    amount_off: number | null;
  };
}
export type ValidatePromotionCodeResponse = FunctionObjectReturn<ValidatePromotionCode>;
